module.exports = __webpack_public_path__ + "img/icon-home-3.3422173b.svg";